// // src/pages/SalesReportPage.jsx
// import React, { useState, useEffect, useRef, useMemo } from "react";
// import styled, { keyframes } from "styled-components";
// import {
//   FaCalendarAlt,
//   FaDownload,
//   FaChartBar,
//   FaClipboardList,
//   FaRupeeSign,
//   FaSyncAlt,
//   FaStar,
//   FaListOl,
// } from "react-icons/fa";
// import html2pdf from "html2pdf.js";

// /* ====== Brand Palette ====== */
// const COLOR = {
//   primary: "#015b9a",
//   primary2: "#0288d1",
//   bg: "#f5f7fb",
//   card: "#ffffff",
//   line: "#e8eef5",
//   text: "#1f2937",
//   muted: "#6b7280",
//   successBg: "#e8f5e9",
//   tableHead: "#e9f4fb",
// };

// const SalesReportPage = () => {
//   const [fromDate, setFromDate] = useState(() =>
//     new Date().toISOString().slice(0, 10)
//   );
//   const [toDate, setToDate] = useState(() =>
//     new Date().toISOString().slice(0, 10)
//   );
//   const [loading, setLoading] = useState(false);
//   const [refreshing, setRefreshing] = useState(false);
//   const [error, setError] = useState("");
//   const [data, setData] = useState({
//     total_sale_count: 0,
//     total_sales_quantity: 0,
//     total_sale_amount: 0,
//     list: [],
//   });
//   const [page, setPage] = useState(0);
//   const rowsPerPage = 10;
//   const [expanded, setExpanded] = useState(new Set());
//   const reportRef = useRef();

//   const pageCount = Math.ceil((data?.list?.length || 0) / rowsPerPage);
//   const start = page * rowsPerPage;
//   const presets = useMemo(() => {
//     const today = new Date();
//     const toISO = (d) => d.toISOString().slice(0, 10);
//     const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
//     const startOfWeek = () => {
//       const t = new Date();
//       const day = t.getDay();
//       const diff = t.getDate() - day + (day === 0 ? -6 : 1); // Monday
//       t.setDate(diff);
//       return t;
//     };
//     const startOfMonth = () => new Date(today.getFullYear(), today.getMonth(), 1);
//     return [
//       { label: "Today", from: toISO(today), to: toISO(today) },
//       { label: "Yesterday", from: toISO(yesterday), to: toISO(yesterday) },
//       { label: "This Week", from: toISO(startOfWeek()), to: toISO(today) },
//       { label: "This Month", from: toISO(startOfMonth()), to: toISO(today) },
//     ];
//   }, []);

//   useEffect(() => {
//     fetchReport();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [fromDate, toDate]);

//   async function fetchReport(opts = {}) {
//     const user = JSON.parse(localStorage.getItem("userData"))?.data;
//     if (!user?.id) return;
//     setError("");
//     if (opts.refresh) setRefreshing(true);
//     else setLoading(true);
//     try {
//       const resp = await fetch(
//         "https://qr.billsarthi.in/public/api/getsalereport",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             restaurantid: user.id,
//             fromdate: fromDate,
//             todate: toDate,
//           }),
//         }
//       );
//       const json = await resp.json();
//       if (resp.ok) {
//         setData(
//           json || {
//             total_sale_count: 0,
//             total_sales_quantity: 0,
//             total_sale_amount: 0,
//             list: [],
//           }
//         );
//         setPage(0);
//         setExpanded(new Set());
//       } else {
//         setError(json.message || "Failed to load report");
//       }
//     } catch (e) {
//       setError(e.message || "Network error");
//     } finally {
//       if (opts.refresh) setRefreshing(false);
//       else setLoading(false);
//     }
//   }

//   const toggle = (sno) => {
//     setExpanded((prev) => {
//       const s = new Set(prev);
//       s.has(sno) ? s.delete(sno) : s.add(sno);
//       return s;
//     });
//   };

//   const exportPDF = () => {
//     if (!reportRef.current || (data?.list?.length || 0) === 0) return;
//     html2pdf()
//       .set({
//         margin: 8,
//         filename: `sales_report_${fromDate}_to_${toDate}.pdf`,
//         html2canvas: { scale: 2 },
//       })
//       .from(reportRef.current)
//       .save();
//   };

//   const fmtINR = useMemo(
//     () =>
//       new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }),
//     []
//   );
//   const fmtDate = (d) => {
//     try {
//       return new Date(d).toLocaleDateString("en-IN", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       });
//     } catch {
//       return d;
//     }
//   };
//   const fmtTime = (d) =>
//     new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });

//   const topItem = useMemo(() => {
//     const tally = {};
//     (data?.list || []).forEach((row) => {
//       (row.summary || []).forEach((item) => {
//         tally[item.item_name] = (tally[item.item_name] || 0) + Number(item.total_quantity || 0);
//       });
//     });
//     const entries = Object.entries(tally);
//     if (!entries.length) return null;
//     const [name, qty] = entries.sort((a, b) => b[1] - a[1])[0];
//     return { name, qty };
//   }, [data]);

//   return (
//     <Page>
//       <TopBar>
//         <TopLeft>
//           <Title>Sales Report</Title>
//           <Sub>Track daily summaries and item-wise breakdowns</Sub>
//           <PresetRow>
//             {presets.map((p) => (
//               <PresetChip
//                 key={p.label}
//                 $active={p.from === fromDate && p.to === toDate}
//                 onClick={() => {
//                   setFromDate(p.from);
//                   setToDate(p.to);
//                 }}
//               >
//                 {p.label}
//               </PresetChip>
//             ))}
//             <RefreshBtn onClick={() => fetchReport({ refresh: true })}>
//               <FaSyncAlt /> {refreshing ? "Refreshing..." : "Refresh"}
//             </RefreshBtn>
//           </PresetRow>
//         </TopLeft>
//         <TopRight>
//           <InputWrap>
//             <InputLabel>
//               <FaCalendarAlt /> From
//             </InputLabel>
//             <DateInput
//               type="date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//               max={toDate}
//             />
//           </InputWrap>
//           <InputWrap>
//             <InputLabel>
//               <FaCalendarAlt /> To
//             </InputLabel>
//             <DateInput
//               type="date"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//               min={fromDate}
//             />
//           </InputWrap>
//           <ExportBtn onClick={exportPDF} disabled={(data?.list || []).length === 0}>
//             <FaDownload /> Export PDF
//           </ExportBtn>
//         </TopRight>
//       </TopBar>

//       <Main ref={reportRef}>
//         <KpiRow>
//           <KpiCard>
//             <KpiIcon style={{ color: COLOR.primary }}>
//               <FaClipboardList />
//             </KpiIcon>
//             <KpiLabel>Total Orders</KpiLabel>
//             <KpiValue>{data.total_sale_count || 0}</KpiValue>
//             <KpiSub>
//               {fromDate} → {toDate}
//             </KpiSub>
//           </KpiCard>
//           <KpiCard>
//             <KpiIcon style={{ color: COLOR.primary2 }}>
//               <FaChartBar />
//             </KpiIcon>
//             <KpiLabel>Total Quantity</KpiLabel>
//             <KpiValue>{data.total_sales_quantity || 0}</KpiValue>
//             <KpiSub>All items combined</KpiSub>
//           </KpiCard>
//           <KpiCard>
//             <KpiIcon style={{ color: "#0f9d58" }}>
//               <FaRupeeSign />
//             </KpiIcon>
//             <KpiLabel>Total Amount</KpiLabel>
//             <KpiValue>
//               {fmtINR.format(Number(data.total_sale_amount || 0))}
//             </KpiValue>
//             <KpiSub>Gross for selected period</KpiSub>
//           </KpiCard>
//         </KpiRow>

//         <BadgeRow>
//           <Pill>Txn: {data.list.length || 0}</Pill>
//           <Pill>Period: {fromDate} → {toDate}</Pill>
//           {topItem ? (
//             <Pill className="accent">
//               <FaStar /> Top item: {topItem.name} ({topItem.qty})
//             </Pill>
//           ) : null}
//         </BadgeRow>

//         {/* Table / Loader */}
//         {loading ? (
//           <Card>
//             <Loader />
//             <LoaderLine />
//             <LoaderLine />
//             <LoaderLine />
//           </Card>
//         ) : (
//           <Card>
//             <Table>
//               <thead>
//                 <tr>
//                   <Th style={{ width: 80 }}>Sr No</Th>
//                   <Th style={{ minWidth: 120 }}>Date</Th>
//                   <Th>Txn No</Th>
//                   <Th style={{ width: 120, textAlign: "right" }}>Qty</Th>
//                   <Th style={{ width: 160, textAlign: "right" }}>Amount</Th>
//                   <Th style={{ width: 120 }}>Time</Th>
//                   <Th style={{ width: 70 }}></Th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.list.slice(start, start + rowsPerPage).map((row) => (
//                   <React.Fragment key={row.sno}>
//                     <tr>
//                       <Td>{row.sno}</Td>
//                       <Td>{fmtDate(row.date)}</Td>
//                       <Td>
//                         <TxnBadge>{row.txn_no}</TxnBadge>
//                       </Td>
//                       <Td style={{ textAlign: "right" }}>
//                         {row.total_quantity}
//                       </Td>
//                       <Td style={{ textAlign: "right", fontWeight: 700 }}>
//                         {fmtINR.format(Number(row.total_amount || 0))}
//                       </Td>
//                       <Td>{fmtTime(row.created_at || row.date)}</Td>
//                       <Td>
//                         <Expand onClick={() => toggle(row.sno)}>
//                           {expanded.has(row.sno) ? "Hide" : "View"}
//                         </Expand>
//                       </Td>
//                     </tr>
//                     {expanded.has(row.sno) && (
//                       <>
//                         <tr className="subHead">
//                           <Td></Td>
//                           <Td
//                             colSpan={2}
//                             style={{ fontWeight: 700, color: COLOR.muted }}
//                           >
//                             Item
//                           </Td>
//                           <Td
//                             style={{
//                               textAlign: "right",
//                               fontWeight: 700,
//                               color: COLOR.muted,
//                             }}
//                           >
//                             Qty
//                           </Td>
//                           <Td
//                             style={{
//                               textAlign: "right",
//                               fontWeight: 700,
//                               color: COLOR.muted,
//                             }}
//                           >
//                             Amount
//                           </Td>
//                           <Td></Td>
//                         </tr>
//                         {row.summary.map((item, i) => (
//                           <tr key={`${row.sno}-${i}`} className="subRow">
//                             <Td>{i + 1}</Td>
//                             <Td colSpan={2}>{item.item_name}</Td>
//                             <Td style={{ textAlign: "right" }}>
//                               {item.total_quantity}
//                             </Td>
//                             <Td style={{ textAlign: "right" }}>
//                               {fmtINR.format(Number(item.total_amount || 0))}
//                             </Td>
//                             <Td></Td>
//                           </tr>
//                         ))}
//                       </>
//                     )}
//                   </React.Fragment>
//                 ))}

//                 {data.list.length === 0 && (
//                   <tr>
//                     <Td
//                       colSpan={6}
//                       style={{
//                         textAlign: "center",
//                         padding: 24,
//                         color: COLOR.muted,
//                       }}
//                     >
//                       No records found for the selected range.
//                     </Td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>

//             {/* Pagination */}
//             <Pager>
//               <PageBtn
//                 disabled={page === 0}
//                 onClick={() => setPage((p) => p - 1)}
//               >
//                 ‹ Prev
//               </PageBtn>
//               <PageInfo>
//                 Page <strong>{pageCount ? page + 1 : 0}</strong> of{" "}
//                 <strong>{pageCount}</strong>
//               </PageInfo>
//               <PageBtn
//                 disabled={page + 1 >= pageCount}
//                 onClick={() => setPage((p) => p + 1)}
//               >
//                 Next ›
//               </PageBtn>
//             </Pager>
//             {error ? <ErrorText>{error}</ErrorText> : null}
//           </Card>
//         )}
//       </Main>
//     </Page>
//   );
// };

// export default SalesReportPage;

// /* ===================== Styles ===================== */

// const Page = styled.div`
//   min-height: 100vh;
//   background: ${COLOR.bg};
//   font-family: Inter, system-ui, Segoe UI, Roboto, "Helvetica Neue", Arial;
//   color: ${COLOR.text};
// `;

// const TopBar = styled.div`
//   position: sticky;
//   top: 0;
//   z-index: 5;
//   background: linear-gradient(90deg, ${COLOR.primary}, ${COLOR.primary2});
//   padding: 16px 20px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   border-bottom: 1px solid #0c6aa8;
// `;

// const TopLeft = styled.div``;
// const Title = styled.h1`
//   color: #fff;
//   margin: 0;
//   font-weight: 800;
//   font-size: 20px;
// `;
// const Sub = styled.div`
//   color: #e3f2fd;
//   font-size: 13px;
//   margin-top: 4px;
// `;
// const PresetRow = styled.div`
//   display: flex;
//   gap: 8px;
//   margin-top: 10px;
//   flex-wrap: wrap;
// `;
// const PresetChip = styled.button`
//   border: 1px solid ${COLOR.line};
//   background: ${({ $active }) => ($active ? "#fff" : "rgba(255,255,255,0.12)")};
//   color: ${({ $active }) => ($active ? COLOR.primary : "#e3f2fd")};
//   border-radius: 999px;
//   padding: 8px 12px;
//   font-weight: 800;
//   cursor: pointer;
//   transition: all 0.15s ease;
//   &:hover {
//     transform: translateY(-1px);
//     box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
//   }
// `;
// const RefreshBtn = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   padding: 8px 12px;
//   border-radius: 10px;
//   border: 1px solid #fff;
//   background: rgba(255, 255, 255, 0.14);
//   color: #fff;
//   font-weight: 800;
//   cursor: pointer;
// `;

// const TopRight = styled.div`
//   display: flex;
//   align-items: end;
//   gap: 10px;
//   flex-wrap: wrap;
// `;

// const InputWrap = styled.div`
//   display: grid;
//   gap: 6px;
// `;
// const InputLabel = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   color: #e3f2fd;
//   font-size: 12px;
//   font-weight: 700;
//   svg {
//     opacity: 0.95;
//   }
// `;
// const DateInput = styled.input`
//   background: #ffffff;
//   border: 1px solid ${COLOR.line};
//   color: ${COLOR.text};
//   border-radius: 10px;
//   padding: 10px 12px;
//   min-width: 180px;
//   outline: none;
//   &:focus {
//     border-color: ${COLOR.primary};
//     box-shadow: 0 0 0 3px rgba(1, 91, 154, 0.12);
//   }
// `;

// const ExportBtn = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 8px;
//   background: #f57c00;
//   color: #fff;
//   border: none;
//   border-radius: 10px;
//   padding: 10px 14px;
//   font-weight: 800;
//   cursor: pointer;
//   &:hover {
//     background: #ef6c00;
//   }
// `;

// const Main = styled.div`
//   padding: 22px;
// `;

// const KpiRow = styled.div`
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   gap: 16px;
//   margin-bottom: 18px;
//   @media (max-width: 900px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const KpiCard = styled.div`
//   background: ${COLOR.card};
//   border: 1px solid ${COLOR.line};
//   border-radius: 16px;
//   padding: 18px;
//   box-shadow: 0 10px 30px rgba(1, 91, 154, 0.08);
//   display: grid;
//   grid-template-columns: auto 1fr;
//   column-gap: 12px;
//   align-items: center;
// `;
// const KpiIcon = styled.div`
//   width: 40px;
//   height: 40px;
//   display: grid;
//   place-items: center;
//   font-size: 20px;
// `;
// const KpiLabel = styled.div`
//   color: ${COLOR.muted};
//   font-weight: 700;
//   font-size: 13px;
// `;
// const KpiValue = styled.div`
//   font-size: 22px;
//   font-weight: 900;
// `;
// const KpiSub = styled.div`
//   color: ${COLOR.muted};
//   font-size: 12px;
//   margin-top: 4px;
// `;

// const BadgeRow = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 10px;
//   margin-bottom: 12px;
// `;
// const Pill = styled.div`
//   display: inline-flex;
//   align-items: center;
//   gap: 8px;
//   background: #ecf2ff;
//   color: ${COLOR.text};
//   border: 1px solid ${COLOR.line};
//   border-radius: 999px;
//   padding: 8px 12px;
//   font-weight: 700;
//   &.accent {
//     background: #fff7ed;
//     border-color: #fed7aa;
//   }
// `;

// const Card = styled.div`
//   background: ${COLOR.card};
//   border: 1px solid ${COLOR.line};
//   border-radius: 16px;
//   padding: 16px;
//   box-shadow: 0 10px 30px rgba(1, 91, 154, 0.08);
// `;

// const Table = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   font-size: 14px;
//   overflow: hidden;
//   border-radius: 12px;
//   thead {
//     background: ${COLOR.tableHead};
//     th {
//       color: ${COLOR.text};
//       font-weight: 800;
//       padding: 12px;
//       text-align: left;
//       border-bottom: 1px solid ${COLOR.line};
//     }
//   }
//   tbody {
//     tr {
//       background: #fff;
//     }
//     tr:nth-child(even) {
//       background: #fbfdff;
//     }
//     tr:hover {
//       background: #f4faff;
//     }
//     .subHead td {
//       background: #f4f7fb;
//       border-top: 1px solid ${COLOR.line};
//       font-size: 13px;
//     }
//     .subRow td {
//       background: ${COLOR.successBg};
//     }
//     td {
//       padding: 12px;
//       border-bottom: 1px solid ${COLOR.line};
//       vertical-align: middle;
//     }
//   }
// `;

// const Th = styled.th``;
// const Td = styled.td``;

// const TxnBadge = styled.span`
//   display: inline-block;
//   background: #ecf5ff;
//   color: ${COLOR.primary};
//   border: 1px solid ${COLOR.primary}22;
//   padding: 6px 10px;
//   border-radius: 999px;
//   font-weight: 800;
// `;

// const Expand = styled.button`
//   background: #eef6ff;
//   color: ${COLOR.primary};
//   border: 1px solid ${COLOR.primary};
//   border-radius: 10px;
//   padding: 6px 10px;
//   font-weight: 800;
//   cursor: pointer;
// `;

// const Pager = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 12px;
//   margin-top: 14px;
// `;
// const PageBtn = styled.button`
//   padding: 8px 14px;
//   border-radius: 10px;
//   border: 1px solid ${COLOR.primary};
//   background: #eef6ff;
//   color: ${COLOR.primary};
//   font-weight: 800;
//   cursor: pointer;
//   &:disabled {
//     opacity: 0.5;
//     cursor: default;
//   }
// `;
// const PageInfo = styled.div`
//   color: ${COLOR.muted};
// `;
// const ErrorText = styled.div`
//   margin-top: 10px;
//   color: #c2410c;
//   text-align: center;
//   font-weight: 700;
// `;

// /* ------- Loader ------- */
// const shimmer = keyframes`
//   0% { background-position: -450px 0; }
//   100% { background-position: 450px 0; }
// `;
// const Loader = styled.div`
//   height: 18px;
//   border-radius: 6px;
//   margin: 4px 0 12px 0;
//   background: linear-gradient(90deg, #eef3f7 25%, #e3edf7 50%, #eef3f7 75%);
//   background-size: 900px 100%;
//   animation: ${shimmer} 1.1s linear infinite;
// `;
// const LoaderLine = styled(Loader)`
//   height: 14px;
// `;
// src/pages/SalesReportPage.jsx
import React, { useState, useEffect, useRef, useMemo } from "react";
import styled, { keyframes } from "styled-components";
import {
  FaCalendarAlt,
  FaDownload,
  FaChartBar,
  FaClipboardList,
  FaRupeeSign,
  FaSyncAlt,
  FaStar,
  FaListOl,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { downloadPDF, printThermal } from "../utils/exportHelpers";

/* ====== Brand Palette ====== */
const COLOR = {
  primary: "#015b9a",
  primary2: "#0288d1",
  bg: "#f5f7fb",
  card: "#ffffff",
  line: "#e8eef5",
  text: "#1f2937",
  muted: "#6b7280",
  successBg: "#e8f5e9",
  tableHead: "#e9f4fb",
};

const SalesReportPage = () => {
  const [fromDate, setFromDate] = useState(() =>
    new Date().toISOString().slice(0, 10)
  );
  const [toDate, setToDate] = useState(() =>
    new Date().toISOString().slice(0, 10)
  );
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState({
    total_sale_count: 0,
    total_sales_quantity: 0,
    total_sale_amount: 0,
    list: [],
  });
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const [expanded, setExpanded] = useState(new Set());
  const reportRef = useRef();

  // ---- Restaurant info (for PDF header) ----
  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userData"))?.data || null;
    } catch (e) {
      return null;
    }
  }, []);

  const restaurantName =
    user?.restaurantname || user?.name || "Restaurant Name";
  const restaurantPhone =
    user?.mobile || user?.phone || user?.contactnumber || null;
  const restaurantAddress =
    user?.address || user?.restaurantaddress || user?.city || null;

  const pageCount = Math.ceil((data?.list?.length || 0) / rowsPerPage);
  const start = page * rowsPerPage;
  const presets = useMemo(() => {
    const today = new Date();
    const toISO = (d) => d.toISOString().slice(0, 10);
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
    const startOfWeek = () => {
      const t = new Date();
      const day = t.getDay();
      const diff = t.getDate() - day + (day === 0 ? -6 : 1); // Monday
      t.setDate(diff);
      return t;
    };
    const startOfMonth = () =>
      new Date(today.getFullYear(), today.getMonth(), 1);
    return [
      { label: "Today", from: toISO(today), to: toISO(today) },
      { label: "Yesterday", from: toISO(yesterday), to: toISO(yesterday) },
      { label: "This Week", from: toISO(startOfWeek()), to: toISO(today) },
      { label: "This Month", from: toISO(startOfMonth()), to: toISO(today) },
    ];
  }, []);

  useEffect(() => {
    fetchReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, toDate]);

  async function fetchReport(opts = {}) {
    const user = JSON.parse(localStorage.getItem("userData"))?.data;
    if (!user?.id) return;
    setError("");
    if (opts.refresh) setRefreshing(true);
    else setLoading(true);
    try {
      const resp = await fetch(
        "https://qr.billsarthi.in/public/api/getsalereport",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            restaurantid: user.id,
            fromdate: fromDate,
            todate: toDate,
          }),
        }
      );
      const json = await resp.json();
      if (resp.ok) {
        setData(
          json || {
            total_sale_count: 0,
            total_sales_quantity: 0,
            total_sale_amount: 0,
            list: [],
          }
        );
        setPage(0);
        setExpanded(new Set());
      } else {
        setError(json.message || "Failed to load report");
      }
    } catch (e) {
      setError(e.message || "Network error");
    } finally {
      if (opts.refresh) setRefreshing(false);
      else setLoading(false);
    }
  }

  const toggle = (sno) => {
    setExpanded((prev) => {
      const s = new Set(prev);
      s.has(sno) ? s.delete(sno) : s.add(sno);
      return s;
    });
  };

  const exportPDF = () => {
    if (!reportRef.current || (data?.list?.length || 0) === 0) return;
    downloadPDF(reportRef.current, `sales_report_${fromDate}_to_${toDate}.pdf`);
  };

  const fmtINR = useMemo(
    () =>
      new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }),
    []
  );
  const fmtDate = (d) => {
    try {
      return new Date(d).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return d;
    }
  };
  const fmtTime = (d) =>
    new Date(d).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });

  const topItem = useMemo(() => {
    const tally = {};
    (data?.list || []).forEach((row) => {
      (row.summary || []).forEach((item) => {
        tally[item.item_name] =
          (tally[item.item_name] || 0) + Number(item.total_quantity || 0);
      });
    });
    const entries = Object.entries(tally);
    if (!entries.length) return null;
    const [name, qty] = entries.sort((a, b) => b[1] - a[1])[0];
    return { name, qty };
  }, [data]);

  const generatedOn = useMemo(
    () =>
      new Date().toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    []
  );

  return (
    <Page>
      <TopBar>
        <TopLeft>
          <Title>Sales Report</Title>
          <Sub>Track daily summaries and item-wise breakdowns</Sub>
          <PresetRow>
            {presets.map((p) => (
              <PresetChip
                key={p.label}
                $active={p.from === fromDate && p.to === toDate}
                onClick={() => {
                  setFromDate(p.from);
                  setToDate(p.to);
                }}
              >
                {p.label}
              </PresetChip>
            ))}
            <RefreshBtn onClick={() => fetchReport({ refresh: true })}>
              <FaSyncAlt /> {refreshing ? "Refreshing..." : "Refresh"}
            </RefreshBtn>
          </PresetRow>
        </TopLeft>
        <TopRight>
          <InputWrap>
            <InputLabel>
              <FaCalendarAlt /> From
            </InputLabel>
            <DateInput
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              max={toDate}
            />
          </InputWrap>
          <InputWrap>
            <InputLabel>
              <FaCalendarAlt /> To
            </InputLabel>
            <DateInput
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              min={fromDate}
            />
          </InputWrap>
          <ExportBtn
            onClick={exportPDF}
            disabled={(data?.list || []).length === 0}
          >
            <FaDownload /> Export PDF
          </ExportBtn>
          <ExportBtn
            onClick={() => printThermal(reportRef.current, `sales_report_${fromDate}_to_${toDate}`)}
            disabled={(data?.list || []).length === 0}
          >
            Thermal Print
          </ExportBtn>
        </TopRight>
      </TopBar>

      {/* ====== PDF CONTENT STARTS HERE ====== */}
      <Main ref={reportRef}>
        {/* PDF / Print Header */}
        <PdfHeaderCard>
          <PdfBrandRow>
            <PdfBrandLeft>
              <PdfRestaurantName>{restaurantName}</PdfRestaurantName>
              {restaurantAddress && (
                <PdfMetaLine>
                  <FaMapMarkerAlt size={10} />
                  <span>{restaurantAddress}</span>
                </PdfMetaLine>
              )}
              {restaurantPhone && (
                <PdfMetaLine>
                  <FaPhoneAlt size={10} />
                  <span>{restaurantPhone}</span>
                </PdfMetaLine>
              )}
            </PdfBrandLeft>
            <PdfBrandRight>
              <PdfReportTitle>Sales Report</PdfReportTitle>
              <PdfMetaRow>
                <PdfMetaItem>
                  <span>Period</span>
                  <strong>
                    {fromDate} → {toDate}
                  </strong>
                </PdfMetaItem>
                <PdfMetaItem>
                  <span>Generated On</span>
                  <strong>{generatedOn}</strong>
                </PdfMetaItem>
              </PdfMetaRow>
            </PdfBrandRight>
          </PdfBrandRow>
          <PdfDivider />
        </PdfHeaderCard>

        <KpiRow>
          <KpiCard>
            <KpiIcon style={{ color: COLOR.primary }}>
              <FaClipboardList />
            </KpiIcon>
            <KpiLabel>Total Orders</KpiLabel>
            <KpiValue>{data.total_sale_count || 0}</KpiValue>
            <KpiSub>
              {fromDate} → {toDate}
            </KpiSub>
          </KpiCard>
          <KpiCard>
            <KpiIcon style={{ color: COLOR.primary2 }}>
              <FaChartBar />
            </KpiIcon>
            <KpiLabel>Total Quantity</KpiLabel>
            <KpiValue>{data.total_sales_quantity || 0}</KpiValue>
            <KpiSub>All items combined</KpiSub>
          </KpiCard>
          <KpiCard>
            <KpiIcon style={{ color: "#0f9d58" }}>
              <FaRupeeSign />
            </KpiIcon>
            <KpiLabel>Total Amount</KpiLabel>
            <KpiValue>
              {fmtINR.format(Number(data.total_sale_amount || 0))}
            </KpiValue>
            <KpiSub>Gross for selected period</KpiSub>
          </KpiCard>
        </KpiRow>

        <BadgeRow>
          <Pill>Txn: {data.list.length || 0}</Pill>
          <Pill>
            Period: {fromDate} → {toDate}
          </Pill>
          {topItem ? (
            <Pill className="accent">
              <FaStar /> Top item: {topItem.name} ({topItem.qty})
            </Pill>
          ) : null}
        </BadgeRow>

        {/* Table / Loader */}
        {loading ? (
          <Card>
            <Loader />
            <LoaderLine />
            <LoaderLine />
            <LoaderLine />
          </Card>
        ) : (
          <>
            <Card>
              <Table>
                <thead>
                  <tr>
                    <Th style={{ width: 80 }}>Sr No</Th>
                    <Th style={{ minWidth: 120 }}>Date</Th>
                    <Th>Txn No</Th>
                    <Th style={{ width: 120, textAlign: "right" }}>Qty</Th>
                    <Th style={{ width: 160, textAlign: "right" }}>Amount</Th>
                    <Th style={{ width: 120 }}>Time</Th>
                    <Th style={{ width: 70 }}></Th>
                  </tr>
                </thead>
                <tbody>
                  {data.list.slice(start, start + rowsPerPage).map((row) => (
                    <React.Fragment key={row.sno}>
                      <tr>
                        <Td>{row.sno}</Td>
                        <Td>{fmtDate(row.date)}</Td>
                        <Td>
                          <TxnBadge>{row.txn_no}</TxnBadge>
                        </Td>
                        <Td style={{ textAlign: "right" }}>
                          {row.total_quantity}
                        </Td>
                        <Td style={{ textAlign: "right", fontWeight: 700 }}>
                          {fmtINR.format(Number(row.total_amount || 0))}
                        </Td>
                        <Td>{fmtTime(row.created_at || row.date)}</Td>
                        <Td>
                          <Expand onClick={() => toggle(row.sno)}>
                            {expanded.has(row.sno) ? "Hide" : "View"}
                          </Expand>
                        </Td>
                      </tr>
                      {expanded.has(row.sno) && (
                        <>
                          <tr className="subHead">
                            <Td></Td>
                            <Td
                              colSpan={2}
                              style={{ fontWeight: 700, color: COLOR.muted }}
                            >
                              Item
                            </Td>
                            <Td
                              style={{
                                textAlign: "right",
                                fontWeight: 700,
                                color: COLOR.muted,
                              }}
                            >
                              Qty
                            </Td>
                            <Td
                              style={{
                                textAlign: "right",
                                fontWeight: 700,
                                color: COLOR.muted,
                              }}
                            >
                              Amount
                            </Td>
                            <Td></Td>
                          </tr>
                          {row.summary.map((item, i) => (
                            <tr key={`${row.sno}-${i}`} className="subRow">
                              <Td>{i + 1}</Td>
                              <Td colSpan={2}>{item.item_name}</Td>
                              <Td style={{ textAlign: "right" }}>
                                {item.total_quantity}
                              </Td>
                              <Td style={{ textAlign: "right" }}>
                                {fmtINR.format(Number(item.total_amount || 0))}
                              </Td>
                              <Td></Td>
                            </tr>
                          ))}
                        </>
                      )}
                    </React.Fragment>
                  ))}

                  {data.list.length === 0 && (
                    <tr>
                      <Td
                        colSpan={7}
                        style={{
                          textAlign: "center",
                          padding: 24,
                          color: COLOR.muted,
                        }}
                      >
                        No records found for the selected range.
                      </Td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {/* Pagination (screen view only, still ok in PDF) */}
              <Pager>
                <PageBtn
                  disabled={page === 0}
                  onClick={() => setPage((p) => p - 1)}
                >
                  ‹ Prev
                </PageBtn>
                <PageInfo>
                  Page <strong>{pageCount ? page + 1 : 0}</strong> of{" "}
                  <strong>{pageCount}</strong>
                </PageInfo>
                <PageBtn
                  disabled={page + 1 >= pageCount}
                  onClick={() => setPage((p) => p + 1)}
                >
                  Next ›
                </PageBtn>
              </Pager>
              {error ? <ErrorText>{error}</ErrorText> : null}
            </Card>

            {/* PDF Footer */}
            <PdfFooter>
              <span>Powered by</span>
              <strong>BillSarthi</strong>
            </PdfFooter>
          </>
        )}
      </Main>
    </Page>
  );
};

export default SalesReportPage;

/* ===================== Styles ===================== */

const Page = styled.div`
  min-height: 100vh;
  background: ${COLOR.bg};
  font-family: Inter, system-ui, Segoe UI, Roboto, "Helvetica Neue", Arial;
  color: ${COLOR.text};
`;

const TopBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  background: linear-gradient(90deg, ${COLOR.primary}, ${COLOR.primary2});
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #0c6aa8;
`;

const TopLeft = styled.div``;
const Title = styled.h1`
  color: #fff;
  margin: 0;
  font-weight: 800;
  font-size: 20px;
`;
const Sub = styled.div`
  color: #e3f2fd;
  font-size: 13px;
  margin-top: 4px;
`;
const PresetRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
`;
const PresetChip = styled.button`
  border: 1px solid ${COLOR.line};
  background: ${({ $active }) => ($active ? "#fff" : "rgba(255,255,255,0.12)")};
  color: ${({ $active }) => ($active ? COLOR.primary : "#e3f2fd")};
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
  }
`;
const RefreshBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #fff;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-weight: 800;
  cursor: pointer;
`;

const TopRight = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  flex-wrap: wrap;
`;

const InputWrap = styled.div`
  display: grid;
  gap: 6px;
`;
const InputLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #e3f2fd;
  font-size: 12px;
  font-weight: 700;
  svg {
    opacity: 0.95;
  }
`;
const DateInput = styled.input`
  background: #ffffff;
  border: 1px solid ${COLOR.line};
  color: ${COLOR.text};
  border-radius: 10px;
  padding: 10px 12px;
  min-width: 180px;
  outline: none;
  &:focus {
    border-color: ${COLOR.primary};
    box-shadow: 0 0 0 3px rgba(1, 91, 154, 0.12);
  }
  @media (max-width: 768px) {
    min-width: 0;
    width: 100%;
  }
`;

const ExportBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f57c00;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 800;
  cursor: pointer;
  &:hover {
    background: #ef6c00;
  }
`;

const Main = styled.div`
  padding: 22px;
  @media (max-width: 768px) {
    padding: 12px;
  }
`;

/* ===== PDF Header Styles ===== */

const PdfHeaderCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid ${COLOR.line};
  padding: 16px 18px;
  margin-bottom: 18px;
  box-shadow: 0 6px 14px rgba(1, 91, 154, 0.06);
`;

const PdfBrandRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: wrap;
`;

const PdfBrandLeft = styled.div`
  min-width: 180px;
  @media (max-width: 768px) {
    min-width: 0;
  }
`;

const PdfRestaurantName = styled.h2`
  margin: 0 0 6px 0;
  font-size: 20px;
  font-weight: 800;
  color: ${COLOR.primary};
`;

const PdfMetaLine = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${COLOR.muted};
  svg {
    opacity: 0.8;
  }
`;

const PdfBrandRight = styled.div`
  text-align: right;
  min-width: 220px;
  @media (max-width: 768px) {
    min-width: 0;
    text-align: left;
  }
`;

const PdfReportTitle = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: ${COLOR.text};
  margin-bottom: 4px;
`;

const PdfMetaRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;
`;

const PdfMetaItem = styled.div`
  font-size: 11px;
  color: ${COLOR.muted};
  span {
    display: block;
    margin-bottom: 2px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  strong {
    color: ${COLOR.text};
  }
`;

const PdfDivider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, ${COLOR.primary}33, transparent);
  margin-top: 10px;
`;

/* ===== PDF Footer Styles ===== */

const PdfFooter = styled.div`
  margin-top: 16px;
  text-align: center;
  font-size: 11px;
  color: ${COLOR.muted};
  padding-top: 8px;
  border-top: 1px dashed ${COLOR.line};
  strong {
    color: ${COLOR.primary};
    margin-left: 4px;
  }
`;

const KpiRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 18px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const KpiCard = styled.div`
  background: ${COLOR.card};
  border: 1px solid ${COLOR.line};
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 10px 30px rgba(1, 91, 154, 0.08);
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 12px;
  align-items: center;
`;
const KpiIcon = styled.div`
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  font-size: 20px;
`;
const KpiLabel = styled.div`
  color: ${COLOR.muted};
  font-weight: 700;
  font-size: 13px;
`;
const KpiValue = styled.div`
  font-size: 22px;
  font-weight: 900;
`;
const KpiSub = styled.div`
  color: ${COLOR.muted};
  font-size: 12px;
  margin-top: 4px;
`;

const BadgeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
`;
const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ecf2ff;
  color: ${COLOR.text};
  border: 1px solid ${COLOR.line};
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 700;
  &.accent {
    background: #fff7ed;
    border-color: #fed7aa;
  }
`;

const Card = styled.div`
  background: ${COLOR.card};
  border: 1px solid ${COLOR.line};
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(1, 91, 154, 0.08);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  overflow: hidden;
  border-radius: 12px;
  thead {
    background: ${COLOR.tableHead};
    th {
      color: ${COLOR.text};
      font-weight: 800;
      padding: 12px;
      text-align: left;
      border-bottom: 1px solid ${COLOR.line};
    }
  }
  tbody {
    tr {
      background: #fff;
    }
    tr:nth-child(even) {
      background: #fbfdff;
    }
    tr:hover {
      background: #f4faff;
    }
    .subHead td {
      background: #f4f7fb;
      border-top: 1px solid ${COLOR.line};
      font-size: 13px;
    }
    .subRow td {
      background: ${COLOR.successBg};
    }
    td {
      padding: 12px;
      border-bottom: 1px solid ${COLOR.line};
      vertical-align: middle;
    }
  }
`;

const Th = styled.th``;
const Td = styled.td``;

const TxnBadge = styled.span`
  display: inline-block;
  background: #ecf5ff;
  color: ${COLOR.primary};
  border: 1px solid ${COLOR.primary}22;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 800;
`;

const Expand = styled.button`
  background: #eef6ff;
  color: ${COLOR.primary};
  border: 1px solid ${COLOR.primary};
  border-radius: 10px;
  padding: 6px 10px;
  font-weight: 800;
  cursor: pointer;
`;

const Pager = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 14px;
`;
const PageBtn = styled.button`
  padding: 8px 14px;
  border-radius: 10px;
  border: 1px solid ${COLOR.primary};
  background: #eef6ff;
  color: ${COLOR.primary};
  font-weight: 800;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
const PageInfo = styled.div`
  color: ${COLOR.muted};
`;
const ErrorText = styled.div`
  margin-top: 10px;
  color: #c2410c;
  text-align: center;
  font-weight: 700;
`;

/* ------- Loader ------- */
const shimmer = keyframes`
  0% { background-position: -450px 0; }
  100% { background-position: 450px 0; }
`;
const Loader = styled.div`
  height: 18px;
  border-radius: 6px;
  margin: 4px 0 12px 0;
  background: linear-gradient(90deg, #eef3f7 25%, #e3edf7 50%, #eef3f7 75%);
  background-size: 900px 100%;
  animation: ${shimmer} 1.1s linear infinite;
`;
const LoaderLine = styled(Loader)`
  height: 14px;
`;
